import { render, staticRenderFns } from "./EditScreensaverLoader.vue?vue&type=template&id=06f0640f"
import script from "./EditScreensaverLoader.vue?vue&type=script&lang=ts"
export * from "./EditScreensaverLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports